'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('custom-list', {
      url: '/custom/:type/list',
      template: '<custom-list></custom-list>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/custom/list/custom-list.routes.js